import { httpApi } from '@api/http.api.ts';
import type { CommonTableRequest } from '@routes/sidebar/admin-center/___shared___/types.ts';
import type { UserType } from '@routes/sidebar/admin-center/tenant-client/___pages___/roles/___shared___/types.ts';
import type { EmptyResultsDescription, PaginatedResponse } from '@types';

export type CommonTenantRequest = CommonTableRequest;

export interface TenantAdminAndCreatorUser {
    id: number;
    firstName: string;
    lastName: string;
    rankOrTitleName: string | null;
    userType: UserType;
}

export interface TenantAdminAndCreatorItem {
    id: number;
    isCreator: boolean;
    modifiedById: number;
    modifiedByTenantAlias: string;
    modifiedBy: string;
    users: TenantAdminAndCreatorUser[];
    version: string | null;
}

export interface UpsertTenantAdminAndCreatorRequest {
    isCreator: boolean;
    userIds: number[];
}

export type TenantAdminAndCreatorSearchResponse = PaginatedResponse<TenantAdminAndCreatorItem, EmptyResultsDescription>;
export type TenantAdminAndCreatorUsersSearchResponse = PaginatedResponse<
    TenantAdminAndCreatorUser,
    EmptyResultsDescription
>;

const getBaseUrl = (tenantAlias: string) => `admin-center/tenants/${tenantAlias}/rbac/tenant-access`;

export const getApiTenantAdminAndCreator = (
    tenantAlias: string,
    payload: CommonTenantRequest,
): Promise<TenantAdminAndCreatorSearchResponse> =>
    httpApi
        .post<TenantAdminAndCreatorSearchResponse>(`${getBaseUrl(tenantAlias)}/search`, payload)
        .then(({ data }) => data);

export const createApiTenantAdminAndCreator = (
    tenantAlias: string,
    payload: UpsertTenantAdminAndCreatorRequest,
): Promise<TenantAdminAndCreatorItem> =>
    httpApi.post<TenantAdminAndCreatorItem>(getBaseUrl(tenantAlias), payload).then(({ data }) => data);

export const updateApiTenantAdminAndCreator = (
    tenantAlias: string,
    accessId: number,
    payload: UpsertTenantAdminAndCreatorRequest,
): Promise<TenantAdminAndCreatorItem> =>
    httpApi.put<TenantAdminAndCreatorItem>(`${getBaseUrl(tenantAlias)}/${accessId}`, payload).then(({ data }) => data);

export const deleteApiTenantAdminAndCreator = (tenantAlias: string, accessId: number): Promise<any> =>
    httpApi.delete<any>(`${getBaseUrl(tenantAlias)}/${accessId}`).then((data) => data);

export const getApiTenantAdminAndCreatorUsers = (
    tenantAlias: string,
    payload: CommonTenantRequest,
): Promise<TenantAdminAndCreatorUsersSearchResponse> =>
    httpApi
        .post<TenantAdminAndCreatorUsersSearchResponse>(`${getBaseUrl(tenantAlias)}/users/search`, payload)
        .then(({ data }) => data);
